<template>
  <div class="container-fluid animalKatta">
    <div class="panel panel-info">
      <!-- <div style="text-align: left" class="p-3 mb-2 bg-primary text-white">
        <b>Dashboard:</b>
      </div> -->
      <div  class="animalKatta p-3 mb-2">
        <h4 style="text-align: left">Dashboard
            <b-button class="float-right"  variant="danger" @click="handleBack"><b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>Back</b-button>
        </h4>
        
          
        <hr/>
      </div>
      <div class="animalKatta panel-body">
        <div class="container">
          <div class="row">
            <div class="col-lg-3 col-sm-6">
              <div class="card-box bg-orange">
                <div class="inner animalKatta" @click="handleAppointment">
                  <h3></h3>
                  <p></p>
                  <p class="animalKatta">Appointments</p>
                </div>
                <div class="icon">
                  <i class="fa fa-user-plus" aria-hidden="true"></i>
                </div>
                <a class="card-box-footer"
                  >View More <i class="fa fa-arrow-circle-right"></i
                ></a>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="card-box bg-red">
                <div class="inner" @click="handleMedical">
                  <h3></h3>
                  <p></p>
                  <p>Request Medical cert.</p>
                </div>
                <div class="icon">
                  <i class="fa fa-users"></i>
                </div>
                <a class="card-box-footer"
                  >View More <i class="fa fa-arrow-circle-right"></i
                ></a>
              </div>
            </div>
            <div class="col-lg-3 col-sm-3">
              <div class="card-box bg-blue">
                <div class="inner" @click="handleProfile">
                  <h3></h3>
                  <p></p>
                  <p>Profile</p>
                </div>
                <div class="icon">
                  <i class="fa fa-graduation-cap" aria-hidden="true"></i>
                </div>
                <a class="card-box-footer"
                  >Details <i class="fa fa-arrow-circle-right"></i
                ></a>
              </div>
            </div>

            <div class="col-lg-3 col-sm-6">
              <div class="card-box bg-green" @click="handleArea">
                <div class="inner">
                  <h3></h3>
                  <p></p>
                  <p style="color: white">My Area</p>
                </div>
                <div class="icon">
                  <i class="fa fa-money" aria-hidden="true"></i>
                </div>
                <a class="card-box-footer"
                  >View More <i class="fa fa-arrow-circle-right"></i
                ></a>
              </div>
            </div>
            <!-- <div class="col-lg-3 col-sm-6">
                <div class="card-box bg-orange">
                    <div class="inner">
                        <h3>  </h3>
                        <p> </p>
                          <router-link
                        style="color:white;"
                        :to="{ name: 'Appointment'}"
                      >Appointments </router-link>
                    </div>
                    <div class="icon">
                        <i class="fa fa-user-plus" aria-hidden="true"></i>
                    </div>
                    <a href="#" class="card-box-footer">View More <i class="fa fa-arrow-circle-right"></i></a>
                </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleArea() {
      this.$router.push("/home/my_area");
    },
    handleProfile() {
      this.$router.push("/home/doctor_profile");
    },
    handleMedical() {
      this.$router.push("/home/pending_request");
    },
    handleAppointment() {
      this.$router.push("/home/Appointment_list");
    },
    handleBack(){
      this.$router.push("/");
    }
  },
};
</script>
<style scoped>
.card-box {
  position: relative;
  color: #fff;
  padding: 20px 10px 40px;
  margin: 20px 0px;
}
.card-box:hover {
  text-decoration: none;
  color: #f1f1f1;
}
.card-box:hover .icon i {
  font-size: 100px;
  transition: 1s;
  -webkit-transition: 1s;
}
.card-box .inner {
  padding: 5px 10px 0 10px;
}
.card-box h3 {
  font-size: 27px;
  font-weight: bold;
  margin: 0 0 8px 0;
  white-space: nowrap;
  padding: 0;
  text-align: left;
}
.card-box p {
  font-size: 15px;
}
.card-box .icon {
  position: absolute;
  top: auto;
  bottom: 5px;
  right: 5px;
  z-index: 0;
  font-size: 72px;
  color: rgba(0, 0, 0, 0.15);
}
.card-box .card-box-footer {
  position: absolute;
  left: 0px;
  bottom: 0px;
  text-align: center;
  padding: 3px 0;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(0, 0, 0, 0.1);
  width: 100%;
  text-decoration: none;
}
.card-box:hover .card-box-footer {
  background: rgba(0, 0, 0, 0.3);
}
.bg-blue {
  background-color: #00c0ef !important;
}
.bg-green {
  background-color: #00a65a !important;
}
.bg-orange {
  background-color: #f39c12 !important;
}
.bg-red {
  background-color: #d9534f !important;
}
</style>